<template>
	<div class="home-page" :style="{ backgroundImage: `url(${bgUrl})` }">
		<div class="container">
			<!-- 左侧内容区域 -->
			<div class="left-section">
				<div class="custom-font" style="font-size: 52px;">Hello!</div>
				<div class="custom-font" style="font-size: 34px;margin-top: 20px;">人工智能硬件研发设计与中试智造概念验证报价获取平台</div>
				<div class="btn custom-font" style="margin-top: 54px;font-size: 26px;">精细设计，按需智造</div>
				<p>
					<a href="/pages?key=about_us" class="link" style="display: flex;align-items: center;">
					了解我们
					<img src="../assets/jt.png" style="width: 22px;height: 9px;margin-left: 10px;"/>
					</a>
				</p>
			</div>
			<!-- 右侧内容区域 -->
			<div class="right-section">
				<div style="text-align: right;">
					<img src="../assets/logo.png" alt="鱼小微logo" class="logo" />
				</div>
				<!-- 研发模块 -->
				<div class="service-block">
					<router-link :to="{path:'/yanfa',query:{admin_id:admin_id}}"><img src="../assets/yanfa.png" alt="我需要研发"/></router-link>
				</div>
				<!-- 制造模块 -->
				<div class="service-block">
					<router-link :to="{path:'/zhizao',query:{admin_id:admin_id}}"><img src="../assets/zhizao.png" alt="我需要制造"/></router-link>
				</div>
				<p class="disclaimer"><a href="/pages?key=mianze" class="link2">免责声明</a></p>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				admin_id: '',
				bgUrl: require('@/assets/bg.png')
			};
		},
		mounted() {
			this.admin_id = this.$route.query.admin_id;
		}
	};
</script>
<style scoped>
	.home-page {
		height: 100vh;
		margin: 0;
		background-size: cover;
		background-position: center;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.container {
		width: 100%;
		display: flex;
		justify-content: space-between;
	}

	.left-section {
		flex: 1;
		color: white;
		padding-top: 100px;
		padding-left: 98px;
	}

	.right-section {
		flex: 1;
		padding: 0px 88px;
	}

	.logo {
		height: 49px;
		margin-top: 30px;
		margin-bottom: 20px;
	}

	.service-block{
		text-align: center;
	}
	
	.service-block img {
		width: auto;
		height: 290px;
	}
	.btn {
		display: inline-block;
		background-color: #ff5a00;
		color: white;
		padding: 10px 20px;
		border-radius: 5px;
		text-decoration: none;
		margin-top: 10px;
	}

	.link {
		color: white;
		text-decoration: none;
	}
	
	
	.link2 {
		color: #333;
		text-decoration: none;
	}

	.disclaimer {
		font-size: 12px;
		text-align: right;
	}
	
	.custom-font {
	  font-family: 'AlimamaFangYuanTiVF-Thin', sans-serif; /* 使用字体 */
	}
</style>